import { defineStore } from 'pinia';
import { useRefreshStore } from '@/common/composables/refreshStore';
import { useListPackageTypes, type ListPackageTypesResponse } from '../api/listPackageTypes';
import { usePackageTypeStore } from 'shared/packages/stores/packageTypeStore';

export const useRefreshPackageTypeStore = defineStore('refresh-package-types', () => {
  const listPackageTypes = useListPackageTypes();
  const store = usePackageTypeStore();

  const { initialize, refresh } = useRefreshStore<ListPackageTypesResponse>({
    fetchFromServer() {
      return listPackageTypes.execute();
    },
    mergeToStore(response) {
      store.clear();
      store.merge(response.packageTypes);
    },
  });

  return {
    initialize,
    refresh,
  };
});
